import { Injectable } from '@angular/core';
import { openTabWithAck, PopupOptions } from '@/utility/popup-util';

@Injectable({ providedIn: 'root' })
export class PopupService {
  openAndConfirm(url: string, opts: PopupOptions = {}) {
    return openTabWithAck(url, opts);
  }
}
